const REDIRECT_QUERY_PARAM = "redirect";

export const buildLoginRedirectUrl = (currentHref: string): string =>
  `/login?${REDIRECT_QUERY_PARAM}=${encodeURIComponent(currentHref)}`;
